import Snackbars from "./snackbars";

export default Snackbars;
